<template>
  <v-card class="d-flex flex-column">
    <v-overlay
      absolute
      opacity="0.8"
      :value="!hasData"
    >
      <span class="text-bold">
        Facebook not linked
      </span>
    </v-overlay>
    <v-card-title class="font-weight-semibold">
      Audience city podium
    </v-card-title>
    <v-card-subtitle>
      {{ subTitle }}
    </v-card-subtitle>

    <v-card-text class="font-weight-semibold text-center text--primary">
      <vue-apex-charts
        :options="chartOptions"
        :series="chartSeries"
      ></vue-apex-charts>
    </v-card-text>
  </v-card>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';

export default {
  components: { VueApexCharts },
  props: {
    data: {
      type: Object,
      default: null,
    },
  },
  setup(props) {
    const audienceCityData = props?.data;
    const chartOptions = {
      legend: {
        show: false,
      },
      chart: {
        height: 350,
        type: 'treemap',
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        treemap: {
          distributed: true,
          enableShades: false,
        },
      },
    };
    const chartSeries = [
      {
        data: (audienceCityData?.data || [{ tinyName: 'no data', value: 100 }]).map((item) => ({
          x: item.tinyName,
          y: item.value,
        })),
      },
    ];

    return {
      chartOptions,
      chartSeries,
      subTitle: audienceCityData?.description,
      hasData: audienceCityData,
    };
  },
};
</script>
